module.exports = __webpack_public_path__ + "assets/img/2.dfc2e8e8.jpg";